@if (columnModel.isEditable && !!control) {
    <mat-checkbox [formControl]="control | formControl" />
} @else {
    <mat-checkbox disabled [checked]="this.getItemValue(this.columnModel.propertyName)" />
}
